import donationWidget from './create-widget.js'

const TEST = false

Raven.config(`https://43f5dc54fc424fa2bf56d9e3e156f05b@sentry.io/176626`, {
	environment: TEST ? `client:development` : `client:production`,
}).install()

const testKey = `pk_test_aK1m1Va97O5mDHkJzxU83okp`
const realKey = `pk_live_V780yJr4Km48R14hfXDoTp0S`

const target = document.getElementById(`target`)

function removeChildren(node) {
	while (node.firstChild) {
		node.removeChild(node.firstChild)
	}
}

removeChildren(target)

donationWidget({
	target,
	stripeCheckoutOptions: {
		key: TEST ? testKey : realKey,
		image: `./bb.png`,
		locale: `auto`,
	},
})
